import { render, staticRenderFns } from "./GenAI.vue?vue&type=template&id=0b3ddf4e&"
import script from "./GenAI.vue?vue&type=script&lang=js&"
export * from "./GenAI.vue?vue&type=script&lang=js&"
import style0 from "./GenAI.vue?vue&type=style&index=0&id=0b3ddf4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports